import React from "react";
import { FluidForm } from "../../shared/FluidForm";
import { SimpleFormProvider } from "../fluidComponents/fluidForm/SimpleFormLoader";
import { useRegisterFormInstance } from "../fluidComponents/fluidForm/FormInstance.service";
import { FieldComponent } from "../fluidComponents/fluidForm/fields/FieldComponent";
import { Button } from "semantic-ui-react";
export function ManualForm() {
    let fluidForm = new FluidForm({
        key: "example-form",
        type: "form",
        fields: [
            { key: "Full Name", label: "Full Name", type: "fullName" },
            { key: "Email", label: "Email", type: "email" },
        ]
    });
    let instanceId = useRegisterFormInstance({ form: fluidForm });
    return (React.createElement("div", null,
        React.createElement("h1", null, "Manual Form"),
        React.createElement(SimpleFormProvider, { formInstance: instanceId, render: (formProps, onSubmit, validationResults) => (React.createElement(React.Fragment, null,
                React.createElement(FieldComponent, { fieldPath: "Full Name" }),
                React.createElement(FieldComponent, { fieldPath: "Email" }),
                React.createElement(Button, { onClick: () => {
                        onSubmit(fluidForm.getFormSubmission());
                    } }, "Submit"))) })));
}
